var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStethoscope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "huge-icon/health/outline/stethoscope",
    clipPath: "url(#clip0_4639_77689)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1244",
    d: "M18.3333 13.3327C18.3333 14.2532 17.5871 14.9993 16.6667 14.9993C15.7462 14.9993 15 14.2532 15 13.3327C15 12.4122 15.7462 11.666 16.6667 11.666C17.5871 11.666 18.3333 12.4122 18.3333 13.3327Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3096",
    d: "M3.33366 2.5V2.5C2.41318 2.5 1.66699 3.24619 1.66699 4.16667V6.66667C1.66699 8.96785 3.53247 10.8333 5.83366 10.8333V10.8333C8.13484 10.8333 10.0003 8.96785 10.0003 6.66667V4.16667C10.0003 3.24619 9.25413 2.5 8.33366 2.5V2.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3099",
    d: "M5.83301 10.834V15.209C5.83301 16.9349 7.23212 18.334 8.95801 18.334V18.334C10.6839 18.334 12.083 16.9349 12.083 15.209V10.6257C12.083 9.36 13.109 8.33398 14.3747 8.33398V8.33398C15.6403 8.33398 16.6663 9.36 16.6663 10.6257V11.6673",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3097",
    d: "M8.33301 1.66602V3.33268",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3098",
    d: "M3.33301 1.66602V3.33268",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4639_77689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default __webpack_public_path__ + "static/media/stethoscope.e4ae290499b0ad8127a050c92b08d23c.svg";
export { ForwardRef as ReactComponent };